import {StringParam, useQueryParam, withDefault} from 'use-query-params';

export const useCollectionTestLeaderboardQueryParams = () => {
    const [tab, setTab] = useQueryParam(
        'tab',
        withDefault(StringParam, 'global')
    );
    const [filter, setFilter] = useQueryParam(
        'filter',
        withDefault(StringParam, 'all_time')
    );

    return {
        tab,
        filter,
        setTab,
        setFilter,
    };
};
